
<div class = "contracts">
  <h1>Contrats</h1>
  <br />
  <h2>Client ({{dealer.customerContracts == undefined ? 0 : dealer.customerContracts?.length}})</h2>

  @if ((dealer.providerContracts.length >= 0)) {
    <app-contracts
      [objectSource]="objectSource"
      [transactionRole]="TransactionRole.CUSTOMER"
      [dealerId]="dealer.username"
      [enableNew]="false">
    </app-contracts>
  }

  <br />

  <h2>Provider ({{dealer.providerContracts == undefined ? 0 : dealer.providerContracts?.length}})</h2>

  @if ((dealer.providerContracts.length >= 0)) {
    <app-contracts
      [objectSource]="objectSource"
      [transactionRole]="TransactionRole.PROVIDER"
      [dealerId]="dealer.username"
      [enableNew]="false">
    </app-contracts>
  }

</div>